<template>
  <div>
    <ProjectDetail :key="itemKey"></ProjectDetail>
  </div>
</template>

<script>
import ProjectDetail from "@/components/ProjectDetail/index.vue";
export default {
  components: {
    ProjectDetail,
  },
  data() {
    return {
      itemKey: 1,
    };
  },
  watch: {
    "$route.params": {
      deep: true,
      immediate: true,
      handler(data, oldData) {
        if (data.projectId == oldData?.projectId) return;
        this.itemKey += 1;
      },
    },
  },
};
</script>

<style></style>
